import { GateGuestDTO } from 'client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'guestItem',
  props: {
    guest: {
      type: Object as PropType<GateGuestDTO>,
      required: true,
    },
  },
  components: {},
  emits: [],
})
export default class GuestItem extends Vue {
  guest!: GateGuestDTO;

  get guestItemIcon() {
    if (this.guest.isOneTimeGuest) {
      return 'guest-one-time.svg';
    } else {
      return 'guest-periodic.svg';
    }
  }

  getParsedDate() {
    if (this.guest.isDateAlways) return '-';
    const options: any = {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    };
    return this.guest.durationUntil?.toLocaleString('en-GB', options);
  }
}
